const secondary = {
    social_bind_with: 'Уже есть аккаунт? Войдите, чтобы привязать {{methods, list(type: disjunction;)}}.',
};
export default Object.freeze(secondary);
